import { getActivePrestataireBrandConfig, getActiveClientBrandConfig, getActivePrestationBrandConfig } from "../../config/environment.config";

/**
 * Vocabulaire par marque pour les textes du nouveau parcours : Teach'r parle
 * de « cours » et d'« élève », Déclarons de « prestation » et de « client »,
 * Verified Trainer de « cours » et de « client ». Un seul mot par concept.
 */
export const vocab = {
    /** « cours » / « prestation » */
    course: () => getActivePrestationBrandConfig(),
    /** « cours » / « prestations » */
    courses: () => getActivePrestationBrandConfig("s"),
    /** « un cours » / « une prestation » */
    aCourse: () => getActivePrestationBrandConfig("", "un ", "une "),
    /** « le cours » / « la prestation » */
    theCourse: () => getActivePrestationBrandConfig("", "le ", "la "),
    /** « ce cours » / « cette prestation » */
    thisCourse: () => getActivePrestationBrandConfig("", "ce ", "cette "),
    /** « du cours » / « de la prestation » */
    ofTheCourse: () => getActivePrestationBrandConfig("", "du ", "de la "),
    /** « premier cours » / « première prestation » */
    firstCourse: () => getActivePrestationBrandConfig("", "premier ", "première "),
    /** « votre premier cours » / « votre première prestation » */
    yourFirstCourse: () => `votre ${getActivePrestationBrandConfig("", "premier ", "première ")}`,
    /** « mon premier cours » / « ma première prestation » */
    myFirstCourse: () => getActivePrestationBrandConfig("", "mon premier ", "ma première "),
    /** « Vous donnez un cours » / « Vous réalisez une prestation » : le verbe qui va avec la prestation */
    giveVerb: () => (getActivePrestationBrandConfig() === "prestation" ? "réalisez" : "donnez"),
    /** « Un seul cours » / « Une seule prestation » */
    singleCourseTitle: () => getActivePrestationBrandConfig("", "Un seul ", "Une seule "),
    /** « Plusieurs cours » / « Plusieurs prestations » */
    multipleCoursesTitle: () => `Plusieurs ${getActivePrestationBrandConfig("s")}`,
    /** « Plusieurs séances » : le même format, nommé par ce qu'on saisit (badge du parcours, carte de choix) */
    multipleSessionsTitle: () => "Plusieurs séances",
    /** « élève » / « client » */
    client: () => getActiveClientBrandConfig(),
    /** « élèves » / « clients » */
    clients: () => getActiveClientBrandConfig("s"),
    /** « professeur », « coach » (Verified Trainer), « prestataire » (Déclarons) : le mot du côté client. */
    teachr: () => getActivePrestataireBrandConfig(),
    yourTeachr: () => `votre ${getActivePrestataireBrandConfig()}`,
    /** « votre élève » / « votre client » */
    yourClient: () => `votre ${getActiveClientBrandConfig()}`,
    /** « l'élève » / « le client » */
    theClient: () => getActiveClientBrandConfig("", "l'", "le "),
    /** « de l'élève » / « du client » */
    ofTheClient: () => getActiveClientBrandConfig("", "de l'", "du "),
    /** « mon élève » / « mon client » */
    myClient: () => `mon ${getActiveClientBrandConfig()}`,
    /** « par élève » / « par client » */
    perClient: () => `par ${getActiveClientBrandConfig()}`,
    /** « déclaré » accordé au genre de la prestation : « déclarée » pour une prestation */
    declared: () => (getActivePrestationBrandConfig() === "prestation" ? "déclarée" : "déclaré"),
    /** « passé » accordé */
    past: () => (getActivePrestationBrandConfig() === "prestation" ? "passée" : "passé"),
    /** « Matière » / « Prestation » (intitulé du champ de l'étape 3) */
    subjectLabel: () => (getActivePrestationBrandConfig() === "prestation" ? "Prestation" : "Matière"),
    subjectLabelLower: () => (getActivePrestationBrandConfig() === "prestation" ? "prestation" : "matière"),
};
